import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText, Paper } from '@mui/material';

const Disclaimer: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box my={4}>
        <Typography variant="h4" gutterBottom>
          Disclaimer
        </Typography>
        <Paper elevation={3} style={{ padding: '16px' }}>
          <Typography variant="body1" paragraph>
            This is open and free software. No guarantees are made regarding the accuracy, reliability, or completeness of the information provided. 
            The use of this software is at your own risk. The authors and contributors are not responsible for any errors or omissions, 
            or for any damages resulting from the use of this software. By using this software, you agree to these terms.
          </Typography>
          <Typography variant="body1" paragraph>
            The software is provided "as is", without warranty of any kind, express or implied, including but not limited to the warranties of 
            merchantability, fitness for a particular purpose, and noninfringement. In no event shall the authors or copyright holders be liable 
            for any claim, damages, or other liability, whether in an action of contract, tort, or otherwise, arising from, out of, or in connection 
            with the software or the use or other dealings in the software.
          </Typography>
          <Typography variant="body1" paragraph>
            This disclaimer is governed by the laws of Germany. If any provision of this disclaimer is found to be unenforceable, 
            the remaining provisions will continue to be in effect.
          </Typography>
          <Typography variant="body1" paragraph>
            By using this software, you acknowledge that you have read this disclaimer and agree to its terms and conditions. If you do not agree 
            to these terms, do not use the software. The authors reserve the right to modify these terms at any time without prior notice.
          </Typography>
          <Typography variant="body1" paragraph>
            No data will be stored on servers. All data will be stored only on the user's browser. We are committed to protecting your privacy 
            and ensuring the security of your data. We do not collect, store, or share any personal information. Any data you provide is used 
            solely for the purpose of enhancing your experience with the software.
          </Typography>
          <Typography variant="body1" paragraph>
            We implement a variety of security measures to maintain the safety of your personal information. However, we cannot guarantee 
            absolute security as no method of transmission over the internet or method of electronic storage is 100% secure.
          </Typography>
          <Typography variant="body1" paragraph>
            This software has no affiliation with TradingView. All rights to TradingView are reserved by their respective owners.
          </Typography>
        </Paper>
        <Box my={4}>
          <Typography variant="h5" gutterBottom>
            License
          </Typography>
          <Paper elevation={3} style={{ padding: '16px' }}>
            <pre>
              {`MIT License

              Copyright (c) 2025 Andreas Jenkuhn

              Permission is hereby granted, free of charge, to any person obtaining a copy
              of this software and associated documentation files (the "Software"), to deal
              in the Software without restriction, including without limitation the rights
              to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              copies of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:

              The above copyright notice and this permission notice shall be included in all
              copies or substantial portions of the Software.

              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              SOFTWARE.`}
            </pre>
          </Paper>
        </Box>
        <Box my={4}>
          <Typography variant="h5" gutterBottom>
            Packages Licensed Under MIT
          </Typography>
          <Paper elevation={3} style={{ padding: '16px' }}>
            <List>
              <ListItem>
                <ListItemText primary="@emotion/react" />
              </ListItem>
              <ListItem>
                <ListItemText primary="@emotion/styled" />
              </ListItem>
              <ListItem>
                <ListItemText primary="@fontsource/roboto" />
              </ListItem>
              <ListItem>
                <ListItemText primary="@mui/icons-material" />
              </ListItem>
              <ListItem>
                <ListItemText primary="@mui/material" />
              </ListItem>
              <ListItem>
                <ListItemText primary="@mui/x-data-grid" />
              </ListItem>
              <ListItem>
                <ListItemText primary="react" />
              </ListItem>
              <ListItem>
                <ListItemText primary="react-dom" />
              </ListItem>
              <ListItem>
                <ListItemText primary="react-dropzone" />
              </ListItem>
              <ListItem>
                <ListItemText primary="react-router" />
              </ListItem>
              <ListItem>
                <ListItemText primary="react-router-dom" />
              </ListItem>
              <ListItem>
                <ListItemText primary="react-scripts" />
              </ListItem>
              <ListItem>
                <ListItemText primary="react-spinners" />
              </ListItem>
              <ListItem>
                <ListItemText primary="recharts" />
              </ListItem>
            </List>
          </Paper>
        </Box>
      </Box>
    </Container>
  );
}

export default Disclaimer;
